import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { C, ff } from './Dashboard/components/dashboardConstants';
import Sidebar from './Dashboard/components/Sidebar';
import Header from '../../components/layout/Header/Header';
import { useAuth } from '../../contexts/AuthContext';
import { getMyTalentProfile } from '../../api/talentApi';
import { resolveProfileImageUrl } from '../../shared/utils/profilePlaceholders';
import PostLoginNoticeModal, { clearPostLoginNoticePending, hidePostLoginNoticeToday, shouldShowPostLoginNotice } from '../../shared/components/PostLoginNoticeModal';

export default function TalentLayout() {
  const { setUserInfo } = useAuth();
  const [showPostLoginNotice, setShowPostLoginNotice] = useState(() => shouldShowPostLoginNotice());
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    getMyTalentProfile().then(p => {
      const stageName = p.stageName || null;
      const realName = p.name || null;
      const displayName = stageName || realName || '';
      const profileImage = resolveProfileImageUrl(p) || null;
      setUserInfo({ name: displayName, profileImage, stageName, realName });
    }).catch(() => {});
  }, [setUserInfo]);

  return (
    <div style={{ minHeight: '100vh', background: C.bg, fontFamily: ff }}>
      {showPostLoginNotice && (
        <PostLoginNoticeModal
          onClose={() => {
            clearPostLoginNoticePending();
            setShowPostLoginNotice(false);
          }}
          onHideToday={() => {
            hidePostLoginNoticeToday();
            setShowPostLoginNotice(false);
          }}
        />
      )}
      <Header isSidebarPage onMenuClick={() => setSidebarOpen(o => !o)} />
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div style={{
        marginLeft: 'clamp(240px, 25vw, 342px)',
        paddingTop: '72px',
        minHeight: '100vh',
      }}
        className="talent-content"
      >
        <Outlet />
      </div>
    </div>
  );
}
